import e from "../shared/ScreenReader.vue.js";
import { SCHEMA_DYNAMIC_SCOPE_SYMBOL as t, resolveDynamicSchema as n, useDynamicScope as ee } from "./helpers/dynamic-scope.js";
import { unwrapForRead as r } from "./helpers/unwrap-for-read.js";
import { inferDiscriminatorMappingComposition as te } from "./helpers/get-compositions-to-render.js";
import { isTypeObject as i } from "./helpers/is-type-object.js";
import { isEmptySchemaObject as a } from "./helpers/is-empty-schema-object.js";
import { isOnSchemaTargetPath as o } from "./helpers/is-on-schema-target-path.js";
import { mergeAllOfSchemas as s } from "./helpers/merge-all-of-schemas.js";
import { partitionAllOfCompositions as c } from "./helpers/partition-all-of-compositions.js";
import { SCHEMA_ANCESTORS_SYMBOL as l } from "./helpers/schema-cycle.js";
import { SCHEMA_TREE_ROOT_SYMBOL as u, toNodeKey as d, useSchemaExpansion as ne } from "./helpers/schema-expansion.js";
import { handleTreeKeydown as re } from "./helpers/schema-keyboard-nav.js";
import { useLocalization as ie } from "./localization/index.js";
import ae from "./SchemaGlyphPuck.vue.js";
import oe from "./SchemaComposition.vue.js";
import se from "./SchemaProperty.vue.js";
import ce from "./SchemaObjectProperties.vue.js";
import { Fragment as le, computed as f, createBlock as p, createCommentVNode as m, createElementBlock as h, createElementVNode as g, createTextVNode as _, createVNode as v, defineComponent as y, inject as b, normalizeClass as x, openBlock as S, provide as C, toDisplayString as w, toRef as ue, unref as T, useId as E, vShow as de, withCtx as fe, withDirectives as pe } from "vue";
import { ScalarMarkdown as D } from "@scalar/components/markdown";
import { pushDynamicScope as O } from "@scalar/workspace-store/helpers/dynamic-ref";
import { resolve as k } from "@scalar/workspace-store/resolve";
//#region src/schema/Schema.vue?vue&type=script&setup=true&lang.ts
var A = {
	key: 0,
	class: "schema-card-description [.schema-card--level-0:nth-of-type(1)>&]:has-[+.schema-properties]:mb-0! [.schema-card--level-0:nth-of-type(1)>&]:has-[+.schema-properties]:border-b-0! [.schema-card--level-0:nth-of-type(1)>&]:has-[+.schema-properties]:pb-0!"
}, j = {
	key: 1,
	class: "text-c-2 py-1.5"
}, M = {
	key: 0,
	class: "schema-properties w-full! rounded-none! border-0!"
}, N = [
	"id",
	"aria-controls",
	"aria-expanded"
], P = { class: "additional-toggle-label" }, F = ["id", "role"], I = /*@__PURE__*/ y({
	__name: "Schema",
	props: {
		schema: {},
		level: { default: 0 },
		depth: { default: 0 },
		name: {},
		compact: { type: Boolean },
		noncollapsible: {
			type: Boolean,
			default: !1
		},
		hideHeading: { type: Boolean },
		hideDescription: {
			type: Boolean,
			default: !1
		},
		additionalProperties: { type: Boolean },
		additionalPropertyCount: {},
		hideModelNames: {
			type: Boolean,
			default: !1
		},
		discriminator: {},
		breadcrumb: {},
		eventBus: {},
		options: {},
		schemaContext: {},
		compositionPath: {},
		cycleKey: {},
		scrollTargetId: {},
		specificationExtension: {},
		expansion: {}
	},
	setup(y) {
		let { translate: I } = ie(), L = f(() => y.additionalPropertyCount === void 0 ? I("schema.showAdditionalProperties") : I(y.additionalPropertyCount === 1 ? "schema.showOneMoreProperty" : "schema.showMoreProperties", { count: y.additionalPropertyCount })), R = f(() => y.hideModelNames || !!y.options.hideModelNames), z = ee(), B = f(() => r(y.schema)), V = f(() => {
			let e = B.value;
			if (!e || typeof e != "object") return e;
			let t = n(e, z);
			return "$ref" in t ? k.schema(t) : t;
		}), H = B.value ? n(B.value, z) : void 0;
		C(t, H ? O(z, H) : z);
		let U = b(l, void 0), W = f(() => y.cycleKey != null && !!U?.has(y.cycleKey)), G = new Set(U ?? []);
		y.cycleKey != null && G.add(y.cycleKey), C(l, G);
		let me = f(() => !!y.options.expandAllSchemaProperties && !W.value), he = f(() => o(d(y.breadcrumb), y.scrollTargetId ?? "")), ge = f(() => y.noncollapsible || me.value || he.value), K = f(() => {
			let e = V.value;
			if (y.hideDescription) return null;
			let t = B.value;
			return t?.allOf && t.allOf.length > 0 && y.name === "Request Body" ? s(t)?.description || null : !e?.description || typeof e.description != "string" || e.enum || !("properties" in e) && !("patternProperties" in e) && !("additionalProperties" in e) && !("allOf" in e) || t?.allOf && c(t).segments.some((t) => t.kind === "object" && t.schema.description === e.description && ("properties" in t.schema || "patternProperties" in t.schema || "additionalProperties" in t.schema) && !t.schema.enum) ? null : e.description;
		}), q = f(() => B.value && !y.discriminator && i(B.value) ? te(B.value, y.options.document) : null), _e = f(() => !q.value && i(V.value)), ve = b(u, !1), J = f(() => y.depth === 0 && !ve);
		C(u, !0);
		let ye = (e) => {
			J.value && y.options.schemaKeyboardNav && re(e);
		}, Y = y.expansion ?? ne(ue(() => y.scrollTargetId ?? "")), be = E(), X = f(() => d(y.breadcrumb) || `~anonymous-${be}`), Z = f(() => y.noncollapsible || Y.isExpanded(X.value, {
			cyclic: W.value,
			defaultOpen: ge.value
		})), Q = f(() => !y.additionalProperties || Z.value), xe = E(), $ = E(), Se = () => {
			y.noncollapsible || Y.setExpanded(X.value, !Z.value);
		};
		return (t, n) => V.value && Object.keys(V.value).length ? (S(), h("div", {
			key: 0,
			class: x(["schema-card", [
				`schema-card--level-${y.level}`,
				{
					"schema-card--compact": y.compact,
					"schema-card--open": Z.value
				},
				{ "additional-card--tree": y.additionalProperties },
				"schema-card--tree",
				{ "schema-tree [--schema-glyph-background:var(--scalar-background-1)] [--schema-glyph-color:var(--scalar-color-2)]": J.value }
			]]),
			onKeydown: ye
		}, [
			K.value ? (S(), h("div", A, [v(T(D), { value: K.value }, null, 8, ["value"])])) : m("", !0),
			T(a)(V.value) ? (S(), h("div", j, w(T(I)("schema.emptyObject")), 1)) : m("", !0),
			g("div", { class: x(["schema-properties", [{ "schema-properties-open": Z.value }, "w-full! rounded-none! border-0! [.schema-card--level-0:nth-of-type(1)>.schema-card-description+&]:mt-0! [.schema-card-description+&]:mt-1.5!"]]) }, [y.additionalProperties ? pe((S(), h("div", M, [g("button", {
				id: T(xe),
				"aria-controls": Q.value ? T($) : void 0,
				"aria-expanded": Z.value,
				class: "schema-card-title schema-card-title--compact group/tree-control additional-toggle--tree font-code text-c-1! relative flex h-auto min-h-8 items-center gap-0! px-0! py-[var(--schema-row-pad,6px)]! text-sm! font-bold!",
				type: "button",
				onClick: Se
			}, [v(ae, { class: "additional-toggle-glyph" }), g("span", P, [_(w(L.value) + " ", 1), y.name ? (S(), p(e, { key: 0 }, {
				default: fe(() => [_(w(T(I)("schema.forName", { name: y.name })), 1)]),
				_: 1
			})) : m("", !0)])], 8, N)], 512)), [[de, !Z.value]]) : m("", !0), Q.value ? (S(), h("ul", {
				key: 1,
				id: T($),
				role: _e.value ? "list" : "presentation"
			}, [q.value ? (S(), p(oe, {
				key: 0,
				breadcrumb: y.breadcrumb,
				compact: y.compact,
				composition: "oneOf",
				compositionPath: y.compositionPath,
				depth: y.depth,
				discriminator: B.value?.discriminator,
				eventBus: y.eventBus,
				expansion: T(Y),
				hideHeading: y.hideHeading,
				hideModelNames: R.value,
				level: y.level,
				name: y.name,
				options: y.options,
				schema: q.value,
				schemaContext: y.schemaContext,
				scrollTargetId: y.scrollTargetId,
				specificationExtension: y.specificationExtension
			}, null, 8, [
				"breadcrumb",
				"compact",
				"compositionPath",
				"depth",
				"discriminator",
				"eventBus",
				"expansion",
				"hideHeading",
				"hideModelNames",
				"level",
				"name",
				"options",
				"schema",
				"schemaContext",
				"scrollTargetId",
				"specificationExtension"
			])) : T(i)(V.value) ? (S(), p(ce, {
				key: 1,
				breadcrumb: y.breadcrumb,
				compact: y.compact,
				compositionPath: y.compositionPath,
				depth: y.depth,
				discriminator: y.discriminator,
				eventBus: y.eventBus,
				expansion: T(Y),
				hideHeading: y.hideHeading,
				hideModelNames: R.value,
				level: y.level + 1,
				options: y.options,
				schema: V.value,
				schemaContext: y.schemaContext,
				scrollTargetId: y.scrollTargetId,
				specificationExtension: y.specificationExtension
			}, null, 8, [
				"breadcrumb",
				"compact",
				"compositionPath",
				"depth",
				"discriminator",
				"eventBus",
				"expansion",
				"hideHeading",
				"hideModelNames",
				"level",
				"options",
				"schema",
				"schemaContext",
				"scrollTargetId",
				"specificationExtension"
			])) : (S(), h(le, { key: 2 }, [V.value ? (S(), p(se, {
				key: 0,
				breadcrumb: y.breadcrumb,
				compact: y.compact,
				compositionPath: y.compositionPath,
				depth: y.depth,
				discriminator: y.discriminator,
				eventBus: y.eventBus,
				expansion: T(Y),
				hideHeading: y.hideHeading,
				hideModelNames: R.value,
				level: y.level,
				options: y.options,
				schema: V.value,
				schemaContext: y.schemaContext,
				scrollTargetId: y.scrollTargetId,
				specificationExtension: y.specificationExtension
			}, null, 8, [
				"breadcrumb",
				"compact",
				"compositionPath",
				"depth",
				"discriminator",
				"eventBus",
				"expansion",
				"hideHeading",
				"hideModelNames",
				"level",
				"options",
				"schema",
				"schemaContext",
				"scrollTargetId",
				"specificationExtension"
			])) : m("", !0)], 64))], 8, F)) : m("", !0)], 2)
		], 34)) : m("", !0);
	}
});
//#endregion
export { I as default };

//# sourceMappingURL=Schema.vue.script.js.map